<template>
    <div v-show="loadingPane" class="search-loading">
        <template v-if="showSpinner">
            <div class="search-loading__spinner">
                <div class='lds-rolling'><div></div></div><div class="loading__label">We will be back with your results right away...</div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "search-loading",
        props: {
            showSpinner: false
        },
        computed: {
            loadingPane() {
                return this.$store.getters.loading
            }
        }
    }
</script>
